import { FieldErrors } from 'react-hook-form';
import { formatPretax } from './form-utils';
import {
  IAddOnlineReceiptRequest,
  IAddStoreReceiptRequest,
} from '../../models/purchase-history';

export const handleDisableBtn = (
  formError: FieldErrors<{
    preTaxAmount: string;
    receiptNumber: string;
    salesDate: string;
    tryAgain404: boolean;
    receiptAlreadyAddedError: boolean;
  }>,
  inputErrors:
    | {
        receiptNumber: string;
        salesDate: string;
        preTaxAmount: string;
      }
    | {
        orderNumber: string;
        orderDate: string;
        email: string;
      },
) => {
  // Create a shallow copy of formError
  const filteredFormError = { ...formError };

  // Remove tryAgain404 and receiptAlreadyAddedError if they exist
  delete filteredFormError.tryAgain404;
  delete filteredFormError.receiptAlreadyAddedError;

  return (
    Object.keys(filteredFormError).length > 0 ||
    Object.values(inputErrors).some((item) => item !== 'success')
  );
};

const formatDate = (date: string) => {
  const newDate = new Date(date).toLocaleDateString('fr-CA', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    timeZone: 'UTC',
  });
  return newDate;
};

export const makeOnlineRequestBody = (
  svocId: string,
  orderNumber: string,
  orderDate: string,
  email: string,
): IAddOnlineReceiptRequest => {
  return {
    customerAccountId: svocId,
    onlineReceipts: [
      {
        orderNumber,
        emailId: email,
        orderDate: formatDate(orderDate),
      },
    ],
  };
};

export const makeInStoreRequestBody = (
  svocId: string,
  receiptNumber: string,
  salesDate: string,
  preTaxAmount: string,
): IAddStoreReceiptRequest => {
  const [storeNumber, registerNumber, transactionId] = receiptNumber.split('-');

  return {
    customerAccountId: svocId,
    storeReceipts: [
      {
        storeNumber,
        transactionId,
        registerNumber,
        preTaxAmount: formatPretax(preTaxAmount),
        saleDate: formatDate(salesDate),
      },
    ],
  };
};
